module.exports = __webpack_public_path__ + "img/sign_count.c69c6b2b.svg";